import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import TypingTagline from './TypingTagline';

const Hero = () => {
    const { t } = useTranslation();

    return (
        <section
            id="hero"
            className="flex items-center justify-center h-screen relative overflow-hidden"
            style={{
                perspective: "1000px"
            }}
        >
            {/* Main content */}
            <motion.div
                className="text-center text-white relative z-10 max-w-4xl px-6"
                initial={{
                    scale: 0.5,
                    opacity: 0,
                    y: 100
                }}
                animate={{
                    scale: 1,
                    opacity: 1,
                    y: 0
                }}
                transition={{
                    duration: 1.5,
                    ease: [0.16, 1, 0.3, 1],
                    staggerChildren: 0.2
                }}
            >
                <motion.h1
                    className="text-6xl md:text-8xl font-bold mb-6 bg-gradient-to-r from-amber-100 via-amber-300 to-orange-400 bg-clip-text text-transparent animate-wave"
                    style={{ backgroundSize: '200% auto' }} // Necessário para a animação de onda funcionar corretamente com gradientes
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5, duration: 1 }}
                >
                    <span className="text-gray-300">{t('hero.greeting')}</span><br />
                    Gustavo Nakamura
                </motion.h1>

                {/* Isolado em componente próprio: o texto troca de letra em letra
                    o tempo todo, e sem isso re-renderizaria o Hero inteiro (h1,
                    parágrafo, botões) a cada ~100ms indefinidamente. */}
                <TypingTagline />

                <motion.p
                    className="text-lg md:text-xl mb-12 text-gray-300 max-w-2xl mx-auto leading-relaxed"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1, duration: 1 }}
                >
                    {t('hero.description')}
                </motion.p>

                <motion.div
                    className="flex flex-col sm:flex-row gap-4 justify-center items-center"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 1.5, duration: 0.8 }}
                >
                    <motion.a
                        href="#about"
                        className="px-8 py-4 border-2 border-white/30 text-white rounded-full font-semibold text-lg glass hover:bg-white/10 transition-all duration-300"
                        whileHover={{ scale: 1.05, y: -2 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        {t('hero.cta')}
                    </motion.a>
                    <motion.a
                        href="#contact"
                        className="px-8 py-4 border-2 border-white/30 text-white rounded-full font-semibold text-lg glass hover:bg-white/10 transition-all duration-300"
                        whileHover={{ scale: 1.05, y: -2 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        {t('contact.title')}
                    </motion.a>
                </motion.div>
            </motion.div>

            {/* Scroll indicator */}
            <motion.div
                className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 2, duration: 1 }}
            >
                <motion.div
                    className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center"
                    animate={{ y: [0, 10, 0] }}
                    transition={{ repeat: Infinity, duration: 2 }}
                >
                    <motion.div
                        className="w-1 h-3 bg-white/50 rounded-full mt-2"
                        animate={{ y: [0, 6, 0] }}
                        transition={{ repeat: Infinity, duration: 2 }}
                    />
                </motion.div>
            </motion.div>
        </section>
    );
};

export default Hero;
